
import { createReducer, on } from '@ngrx/store';
import { loadLanguageData, loadLanguageDataSuccess, loadLanguageDataFailure } from '../actions';

export interface State {
  languageData: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  languageData: [],
  loading: false,
  error: null,
};

export const languageReducer = createReducer(
  initialState,
  on(loadLanguageData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadLanguageDataSuccess, (state, { languageData }) => {
    // console.log({languageData})
    return ({
    ...state,
    loading: false,
    languageData: languageData,
  })}),
  on(loadLanguageDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
